export const SET_ONBOARD_ACTIVE = 'OnboardTour/SET_TOUR_ACTIVE';

export function setOnboardActive(active) {
  return {
    type: SET_ONBOARD_ACTIVE,
    payload: { active }
  };
}
